import { createSelector } from '@ngrx/store';
import { RootState } from '../../index';

const NAME_WITH_ID = /^\[/;

const selectSalesOrganisations = (state: RootState) => state.session.userContext.salesOrganisations;

export const selectSalesOrganisationsWithId = createSelector(
  selectSalesOrganisations,
  salesOrganisations => {
    return salesOrganisations?.map(salesOrganisation => {
      if (!isNameWithId(salesOrganisation.name)) {
        return addIdToName(salesOrganisation, salesOrganisation.id, salesOrganisation.name);
      }
      return salesOrganisation;
    });
  }
);

function isNameWithId(name: string): boolean {
  return NAME_WITH_ID.test(name);
}

function addIdToName<T extends Object>(object: T, id: string, name: string): T {
  return {
    ...object,
    name: `[${id}] ${name}`
  }
}
